export const webinarStrings = {
  pageTitle: "Webinars / MasterClass",
  newEvent: "Nuevo webinar",
  editEvent: "Editar webinar",
  eventsListTitle: "Eventos",
  eventsFilterAll: "Todos",
  eventsFilterDraft: "Borrador",
  eventsFilterActive: "Activo",
  eventsFilterClosed: "Cerrado",
  noEvents: "No hay eventos de webinar.",
  selectEventHint: "Selecciona un evento para ver el detalle y los leads.",
  detailTitle: "Detalle del evento",
  fieldName: "Nombre",
  fieldLastName: "Apellido",
  fieldPhone: "Teléfono",
  fieldPhoneHint: "Incluye código de país (ej. 57300…)",
  fieldEmail: "Email",
  fieldDayLabel: "Día (plantilla)",
  fieldDateText: "Fecha (plantilla)",
  fieldTimeText: "Hora (plantilla)",
  fieldMeetLink: "Link Meet",
  fieldStatus: "Estado",
  fieldScheduledAt: "Fecha y hora del webinar",
  scheduledAtTimezoneHint: "Hora en America/Bogota (Colombia)",
  templatePreviewTitle: "Vista previa plantilla WhatsApp",
  meetAutoCreateHint:
    "El link de Google Meet se crea automáticamente en el calendario del CRM al guardar.",
  meetPending: "Meet pendiente de sincronizar",
  statusDraft: "Borrador",
  statusActive: "Activo",
  statusClosed: "Cerrado",
  save: "Guardar",
  cancel: "Cancelar",
  edit: "Editar",
  deleteEvent: "Eliminar",
  deleteConfirm:
    "¿Eliminar este webinar? Se borrará también el evento de Google Calendar. Los leads registrados se conservan.",
  deleting: "Eliminando…",
  deleteError: "No se pudo eliminar el evento",
  leadsTitle: "Leads",
  addLead: "Agregar",
  addLeadTitle: "Agregar lead",
  addLeadHint:
    "Se registra en este webinar y se envía la plantilla WhatsApp si hay link de Meet.",
  savingLead: "Guardando…",
  importLeads: "Importar",
  importLeadsTitle: "Importar leads (CSV / Excel)",
  importLeadsHint:
    "Descarga la plantilla, completa name, lastName, phone y email. Al importar se envía la plantilla WhatsApp a cada lead válido.",
  importDownloadTemplate: "Descargar plantilla",
  importSelectFile: "Cargar archivo",
  importColumnsError:
    "No se encontraron filas válidas. Cabeceras requeridas: name, phone (lastName y email opcionales).",
  importParseError: "No se pudo leer el archivo",
  importValid: "válidos",
  importInvalid: "con error",
  importValidation: "Validación",
  importOk: "OK",
  importConfirm: "Importar",
  importing: "Importando…",
  refreshLeads: "Actualizar",
  leadsFilterAll: "Todos",
  leadsFilterRegistered: "Registrados",
  leadsFilterConverted: "Convertidos",
  leadsFilterDiscarded: "Descartados",
  columnName: "Nombre",
  columnPhone: "Teléfono",
  columnEmail: "Email",
  columnNotification: "Notificación",
  columnCustomer: "Cliente",
  columnLeadStatus: "Estado",
  columnActions: "Acciones",
  notificationSent: "Enviada",
  notificationPending: "Pendiente",
  notificationError: "Error",
  noCustomer: "—",
  viewCustomer: "Ver cliente",
  convertToCustomer: "Convertir a cliente",
  convertConfirm: "¿Convertir este lead en cliente CRM?",
  converting: "Convirtiendo…",
  deleteLead: "Eliminar",
  deleteLeadConfirm:
    "¿Eliminar este lead de la lista? El cliente CRM vinculado (si existe) no se borra.",
  deletingLead: "Eliminando…",
  viewFormData: "Formulario",
  viewFormDataTitle: "Respuestas del formulario Meta",
  noFormData: "No hay respuestas de formulario guardadas para este lead.",
  campaignLabel: "Campaña",
  platformLabel: "Plataforma",
  noLeads: "No hay leads para este evento.",
  leadsTotal: "Total",
  loading: "Cargando…",
  meetOpen: "Abrir Meet",
} as const
